import {SessionStorageService} from 'ngx-webstorage';

export const TOKEN_RESPONSE = 'token-response';
export const RETURN_URL = 'return-url';

export function saveReturnUrl(sessionStorageService: SessionStorageService, url: string): void {
    const queryStartIndex = url.indexOf('?');
    const path = queryStartIndex > -1 ? url.substring(1, queryStartIndex) : url.substring(1);
    const queryParams: Record<string, string> = {};
    if (queryStartIndex > -1) {
        new URLSearchParams(url.substring(queryStartIndex)).forEach((value, key) => queryParams[key] = value);
    }
    sessionStorageService.store(RETURN_URL, JSON.stringify({
        path,
        queryParams: Object.keys(queryParams).length ? queryParams : undefined,
    }));
}
